<template>

    <CRow>
        <CCol col="12" lg="8">
            <CCard>
                <CCardHeader>
                    <strong>{{ product.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <CNav variant="tabs">
                        <CNavItem active>
                            Карточка
                        </CNavItem>
                        <CNavItem :to="`/entities/${$route.params.code}/${$route.params.id}/products/${$route.params.entity_product_id}/edit`">
                            Редактировать
                        </CNavItem>
                        <CNavItem :to="`/entities/${$route.params.code}/${$route.params.id}/products/${$route.params.entity_product_id}/categories`">
                            Категории
                        </CNavItem>
                        <CNavItem :to="`/entities/${$route.params.code}/${$route.params.id}/products/${$route.params.entity_product_id}/options`">
                            Опции
                        </CNavItem>
                        <CNavItem :to="`/entities/${$route.params.code}/${$route.params.id}/products/${$route.params.entity_product_id}/variants`">
                            Варианты
                        </CNavItem>
                    </CNav>
                    <CRow class="pl-3 pb-3" />
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Название</CCol>
                        <CCol sm="9" class="col-form-label">{{ product.title }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Внешний ID</CCol>
                        <CCol sm="9" class="col-form-label">{{ product.external_id }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Картинка</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="pictureUrl"
                                class="m2"
                                width="300" />
                        </CCol>
                    </CRow>

                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Описание</CCol>
                        <CCol sm="9" class="col-form-label">{{ product.description }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Кнопка "В корзину", текст</CCol>
                        <CCol sm="9" class="col-form-label">{{ product.cart_button_title || '—' }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Кнопка "В корзину", ссылка</CCol>
                        <CCol sm="9" class="col-form-label">{{ product.cart_button_link || '—' }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Время выполнения</CCol>
                        <CCol sm="9" class="col-form-label">{{ product.lead_time }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Количество (шт)</CCol>
                        <CCol sm="9" class="col-form-label">{{ product.quantity }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Состав</CCol>
                        <CCol sm="9" class="col-form-label">{{ product.composition }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Содержит</CCol>
                        <CCol sm="9" class="col-form-label">{{ product.allergens }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Доступное количество опций</CCol>
                        <CCol sm="9" class="col-form-label">{{ product.options_limit ? product.options_limit : '' }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Цена</CCol>
                        <CCol sm="9" class="col-form-label">{{ product.price }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Ставка НДС</CCol>
                        <CCol sm="9" class="col-form-label">{{ vatLabel }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Вес ({{ UNITS_ENUM[product.units] }})</CCol>
                        <CCol sm="9" class="col-form-label">{{ product.weight }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Калории</CCol>
                        <CCol sm="9" class="col-form-label">{{ product.calories }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Показывать цену "От"</CCol>
                        <CCol sm="9" class="col-form-label">{{ product.show_min_sum ? 'По умолчанию' : 'Нет' }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Энергетик (18+)</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(product.energetic)">
                                &nbsp;{{ product.energetic ? 'Да' : 'Нет' }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Популярный</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(product.popular)">
                                &nbsp;{{ product.popular ? 'Да' : 'Нет' }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Активен</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(product.enabled)">
                                &nbsp;{{ product.enabled ? 'Да' : 'Нет' }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="goBack">Назад</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

    </CRow>
</template>

<script>
    import Vue from 'vue';
    import { UNITS_ENUM } from '@/utils/units';

    export default {

        name: 'EntityProduct',
  
        data () {
            return {
                entity: {},
                product: {},
                UNITS_ENUM
            }
        },
    
        computed: {
            pictureUrl() {
                if(this.entity.picture) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.product.picture;
                } else {
                    return '';
                }
            },
            vatLabel() {
                const vatMap = {
                    0: 'НДС 0%',
                    5: 'НДС 5%',
                    10: 'НДС 10%',
                    20: 'НДС 20%',
                    110: 'Расчетный НДС 10/110',
                    120: 'Расчетный НДС 20/120',
                };
                return vatMap[this.product.vat] || 'НДС не облагается';
            },
        },
  
        mounted() {
            const id = parseInt(this.$route.params.id);
            const product_id = parseInt(this.$route.params.entity_product_id);
            Vue.axios.get(`/entities/get/${id}`)
                .then(resp => {
                    this.entity = resp.data;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            Vue.axios.get(`/entities/${id}/entity_products/${product_id}`)
                .then(resp => {
                    this.product = resp.data;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },
        methods: {
            goBack() {
                this.$router.push({ path:  `/entities/${this.entity.entityType.code}/${this.entity.id}/products/` })
            },
            getBadge (status) {
                return status ? 'success' : 'secondary';
            },
        }
    }

</script>
<style lang="scss" scoped>

</style>
